import { QueryClient } from 'react-query';

// Create a client
export const queryClient = new QueryClient();
